export default (theme) => ({
    root: {},
    withPostComponent: {
        display: 'flex',
        alignItems: 'center',
    },
    tabsContainer: {
        position: 'relative',
        overflow: 'hidden',
    },
    tabsBottom: {
        borderTop: `2px solid ${theme.colors.grey[100]}`,
    },
    navContainer: {
        fontSize: '14px',
        lineHeight: '1.5',
        overflow: 'hidden',
        position: 'relative',
        whiteSpace: 'nowrap',
        outline: 'none',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
    navArrowBase: {
        userSelect: 'none',
        zIndex: 2,
        lineHeight: '20px',
        border: 'none',
        position: 'absolute',
        display: 'none',
        alignItems: 'center',
        overflow: 'hidden',
        top: 0,
        bottom: 0,
        width: '32px',
        pointerEvents: 'none',
    },
    navPrev: {
        background: `linear-gradient(to right, ${theme.colors.primary.white} 60%, transparent 100%)`,
        justifyContent: 'flex-start',
        paddingLeft: '8px',
        left: 0,
    },
    navNext: {
        background: `linear-gradient(to left, ${theme.colors.primary.white} 60%, transparent 100%)`,
        justifyContent: 'flex-end',
        paddingRight: '8px',
        right: 0,
    },
    navArrowShow: {
        display: 'flex !important',
    },
    navBtnDisabled: {
        color: '#ccc',
        opacity: '0.5 !important',
        '& $navArrowIcon': {
            cursor: 'default',
            pointerEvents: 'none',
        },
    },
    navArrowIcon: {
        pointerEvents: 'auto',
        cursor: 'pointer',
    },
    navWrap: {
        overflow: 'auto',
        width: '100%',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    navScroll: {
        display: 'inline-block',
    },
    navScrollWithPadding: {
        paddingLeft: '32px',
        paddingRight: '32px',
    },
    navSwipe: {
        position: 'relative',
    },
    nav: {
        display: 'flex',
        flex: 1,
        width: '100%',
        position: 'relative',
        margin: 0,
        padding: 0,
        listStyle: 'none',
        transformOrigin: '0 0',
        '& > div:not([class])': {
            display: 'flex',
            flexFlow: 'row nowrap',
            flex: 1,
        },
    },
    navAnimated: {
        transition: 'transform 0.5s cubic-bezier(0.35, 0, 0.25, 1)',
        transitionDelay: '.5s',
    },
    tab: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'row nowrap',
        gap: 8,
        transition: 'color 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
        padding: '12px 16px',
        lineHeight: '20px',
        cursor: 'pointer',
        ...theme.typography.defaultText,
        color: theme.colors.grey[500],
        outline: 'none',
        '&:hover': {
            color: theme.colors.actionMinor[600],
        },
    },
    tabActive: {
        color: theme.colors.actionMinor[500],
        cursor: 'default',
    },
    tabDisabled: {
        cursor: 'default',
        color: '#ccc',
        '&:hover': {
            color: '#ccc',
        },
    },
    tabWithPopover: {
        display: 'flex',
        gap: 8,
        alignItems: 'center',
    },
    inkBar: {
        height: '1px',
        bottom: 0,
        left: 0,
        position: 'absolute',
        backgroundColor: theme.colors.actionMinor[500],
        transition: 'left 0.3s, width 0.3s',
    },
    content: {
        width: '100%',
    },
    contentAnimated: {
        transition:
            'margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
        display: 'flex',
        willChange: 'transform',
        flexDirection: 'row',
    },
    tabPane: {
        overflow: 'auto',
        flexShrink: 0,
        width: '100%',
        display: 'block',
    },
    tabPaneInactive: {
        display: 'none',
    },
    popover: {
        display: 'none',
        position: 'absolute',
        background: theme.colors.primary.white,
        boxShadow: `0px 4px 5px 0px rgba(39, 60, 80, 0.2),
                    0px 3px 14px 0px rgba(39, 60, 80, 0.12),
                    0px 8px 10px 0px rgba(39, 60, 80, 0.14)`,
        borderRadius: '6px',
    },
    postComponent: {},
});
